import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { agree } from '@/js/lib/api/account/your/account';
import { useUserStore } from '@/js/lib/store/user';
import { info, loading } from '@/js/lib/ui';
import { PERMISSION_ID_POLICY_UPDATE_202403 } from '@/js/data/permission';
import IButton from '@/js/components/molecules/IButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'update-policy-202403',
  setup(__props) {

const userStore = useUserStore();
const onClickAgree = () => {
  loading({
    asyncFunc: async () => {
      try {
        await agree({ settingId: PERMISSION_ID_POLICY_UPDATE_202403 });
        userStore.updatePermission([PERMISSION_ID_POLICY_UPDATE_202403]);
      } catch (error) {
        info(error, { fadeOut: false });
      }
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style.title)
    }, "iichiのプライバシーポリシーが変更されました", 2),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style.lead)
    }, _cache[0] || (_cache[0] = [
      _createTextVNode("\n      続けるには", -1),
      _createElementVNode("a", {
        class: "external",
        href: "/privacy",
        target: "_blank"
      }, "プライバシーポリシー", -1),
      _createTextVNode("を確認の上、同意が必要です。", -1),
      _createElementVNode("br", null, null, -1),
      _createTextVNode("\n      プライバシーポリシー改定のお知らせは", -1),
      _createElementVNode("a", {
        class: "external",
        href: "/news/ql1jaubbuby",
        target: "_blank"
      }, "こちら", -1),
      _createTextVNode("。\n    ", -1)
    ]), 2),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createVNode(IButton, {
      type: "primary",
      onClick: onClickAgree
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("同意する", -1)
      ])),
      _: 1,
      __: [1]
    }),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style.logout)
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("a", { href: "/signout" }, "同意しない（ログアウト）", -1)
    ]), 2)
  ], 2))
}
}

})